<script lang="ts">
import { defineComponent } from 'vue';
import { useAppStore } from '@/stores/app';
import { mapActions, mapState } from 'pinia';

export default defineComponent({
  name: 'clipboard-icon',
  computed: {
    ...mapState(useAppStore, ['clipboard']),
  },
  methods: {
    ...mapActions(useAppStore, ['copyToClipboard']),
  },
  props: ['text', 'icon', 'iconClass', 'hideIcon'],
});
</script>

<template>
  <div
    @click="copyToClipboard(text)"
    :class="{
      'cursor-pointer inline-block': true,
      'text-yellow-400': text === clipboard,
      [`${$attrs.class}`]: true,
      localOpacity: true
    }"
  >
    <i v-if="!hideIcon" :class="{ pi: true, [icon || 'pi-clone']: true, [iconClass]: true }" />
    <slot />
  </div>
</template>

<style scoped lang="scss">
.localOpacity {
  @apply opacity-40;
  &:hover {
    @apply opacity-100;
  }
}
</style>
